module.exports = __webpack_public_path__ + "img/09_Sanitaerinstallateur_Foto_2022.027efcac.jpg";